<div *ngIf="shipment" class="header">
    <div class="chevron">
        <i class="fa fa-chevron-circle-right" [ngClass]="{'showStats':showStats}" aria-hidden="true"
            (click)="toggleView()"></i>
    </div>
    <div class="rest">
        <div *ngIf="!showStats" class="container-tags" [@fadeInOut]>
            <div class="container-tag">
                <span class="mini-title-tags" *ngIf="shipment.userTags">{{'TAG.USER.CAPTION' | translate}}:</span>
                <shared-tags-strip-component class="only-single" [tags]="shipment.userTags">
                </shared-tags-strip-component>
            </div>
            <div class="container-tag">
                <span class="mini-title-tags only-hardman-user"
                    *ngIf="shipment.internalTags">{{'TAG.INTERNAL.CAPTION' | translate}}:</span>
                <shared-tags-strip-component class="only-single only-hardman-user" [tags]="shipment.internalTags">
                </shared-tags-strip-component>
            </div>
            <div class="container-tag">
                <span class="mini-title-tags only-hardman-user"
                    *ngIf="shipment.incidentTags">{{'TAG.INCIDENT.CAPTION' | translate}}:</span>
                <shared-tags-strip-component class="only-single only-hardman-user" [tags]="shipment.incidentTags">
                </shared-tags-strip-component>
            </div>
        </div>
        <div *ngIf="showStats" class="container-tags stats" [@fadeInOut]>
            <div class="container-tag" *ngIf="delivery">
                <span class="mini-title-tags">{{'SHIPMENTDELIVERY.TOTALKG.CAPTION' | translate}}:</span>
                <span class="stat-value">{{delivery.totalKg}}</span>
            </div>
            <div class="container-tag" *ngIf="delivery">
                <span class="mini-title-tags">{{'SHIPMENTDELIVERY.TOTALM3.CAPTION' | translate}}:</span>
                <span class="stat-value">{{delivery.totalM3}}</span>
            </div>
            <div class="container-tag" *ngIf="delivery">
                <span class="mini-title-tags">{{'SHIPMENTDELIVERY.TOTALPALLET.CAPTION' | translate}}:</span>
                <span class="stat-value">{{delivery.totalPallet}}</span>
            </div>
            <div class="container-tag distance">
                <span class="mini-title-tags">{{'MOBILE.ROUTE.PHASE.ROAD.COMPONENT.THEORETICALDISTANCE.CAPTION' |
                    translate}}:</span>
                <span class="stat-value"></span>
            </div>
        </div>
    </div>
</div>
